import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Authorization from 'containers/Authorization';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import { openFacilityStylesModal } from '../../../../../../web/store/modules/pageBuilder';
import style from './PageListActions.scss';

const propTypes = {
  page: PropTypes.object.isRequired,
  asTopMenuOpt: PropTypes.bool,
  singleBtn: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  disabledRow: PropTypes.bool.isRequired,
};

const FacilityImageAction = ({
  page, singleBtn, onClick, disabledRow,
}) => {
  const { facilityId, companyId } = page;
  return (
    <Authorization facilityId={facilityId} companyId={companyId}>
      {(authorized) => {
        const auth = authorized && !disabledRow;

        return (
          <span className={cx(style.topBtnWrapper, { [style.disabledBtnWrapper]: !auth })}>
            <Button
              onClick={() => onClick(facilityId)}
              variant="default"
              className={cx(style.topBtn, { [style.singleBtn]: singleBtn, [style.disabledBtn]: !auth })}
            >
                  Facility Image
            </Button>
          </span>
        );
      }}
    </Authorization>
  );
};

FacilityImageAction.propTypes = propTypes;

export default connect(
  null,
  dispatch => ({
    onClick: facilityId => dispatch(openFacilityStylesModal(facilityId)),
  }),
)(FacilityImageAction);
